import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'antd'
import TextInput from '../../../../components/common/TextInput/TextInput'
import CustomTable from '../../../../components/common/Table/CustomTable'
import { initFilterInput, renderColumnsSelectGadai } from '../constants'
import { AxiosCustomGet } from '../../../../components/axios/AxiosCustom'
import Cookies from "js-cookie";
import Config from "../../../../components/axios/Config";
import SwalToast from '../../../../components/helpers/SwalToast'
import { convertListGadai } from '../helpers/convertListGadai'

export default function ModalSelectGadaiBySbg({ visible, onClose, handleCheck, selected, onSubmit }) {

    const [loading, setLoading] = useState(false)
    const [tablePagination, setTablePagination] = useState({});
    const [filterInput, setFilterInput] = useState(initFilterInput);
    const [data, setData] = useState(initFilterInput);

    useEffect(() => {
        getData();
    }, [filterInput]);

    const getData = () => {
        let url = `${process.env.REACT_APP_BASE_API_URL}list-gadai/gadai-pagination-for-voucher`;
        let params = {
            search: filterInput.search,
            page: filterInput.page,
            size: filterInput.pageSize,
        };
        AxiosCustomGet(
            url,
            Config(
                {
                    Authorization: `Bearer ${Cookies.get("access_token")}`,
                },
                params
            ),
            (response) => {
                let data = response.data.data;
                // console.log(JSON.stringify(data))
                setData(convertListGadai(data.items))
                setLoading(false);
                setTablePagination({
                    current: response.data.data?.page,
                    pageSize: response.data.data?.per_page,
                    total: response.data.data?.total_item,
                });
            },
            (error) => {
                console.log(error);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const handleTableChange = (pagination) => {
        setFilterInput((prev) => ({
            ...prev,
            page: pagination.current,
            pageSize: parseInt(pagination.pageSize),
        }));
    };

    const handleFilter = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            setFilterInput((prev) => ({
                ...prev,
                search: e.target.value,
            }));
        }
    };

    const handleEnter =
        (type = "enter") =>
            (event) => {
                const { name, value } = event.target;
                if (event.keyCode === 13 || type === "blur") {
                    setFilterInput((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }
            };

    return (
        <Modal
            centered
            title="Pilih No. SBG Untuk Diberikan Voucher"
            className="modal-form"
            visible={visible}
            onCancel={onClose}
            width={800}
            footer={[
                <Button
                    onClick={onClose}
                    style={{
                        border: "0.75px solid #DCDCDC",
                        borderRadius: 6,
                        width: 120,
                        height: 36,
                        color: "#000",
                        background: "#FFFFFF",
                    }}
                >
                    Kembali
                </Button>,
                <Button
                    onClick={onSubmit}
                    disabled={JSON.stringify(selected) === '{}'}
                    style={{
                        border: "0.75px solid #DCDCDC",
                        borderRadius: 6,
                        width: 120,
                        height: 36,
                        color: "#fff",
                        background: JSON.stringify(selected) === '{}' ? '#A6A6A6' : "#2C465C",
                    }}
                >
                    Selanjutnya
                </Button>
            ]}
        >

            <div>
                <TextInput
                    label="No. SBG / Nama Nasabah"
                    id="search"
                    handleEnter={handleEnter}
                    handleChange={handleFilter}
                    width={"50%"}
                />
                <div className="mt-3">
                    <CustomTable
                        onRow={(record, rowIndex) => {
                            return {
                                onClick: event => handleCheck(record)
                            };
                        }}
                        columns={renderColumnsSelectGadai(handleCheck, selected)}
                        data={data}
                        loading={loading}
                        handleTableChange={handleTableChange}
                        pagination={tablePagination}
                    />
                </div>
                <div>
                    Dipilih : <span style={{ fontWeight: '600', color: '#2C465C' }}>{selected.sbg || '-'}</span>
                </div>
            </div>

        </Modal>
    )
}
